export default __webpack_public_path__ + "static/media/screencapture-creativeagency-87a4e-web-app-2021-10-02-23_28_26.d07f820c.png";